import { BASEURL } from "../BaseUrl";

/**
 * Fetches a list of projects from the Benchling API.
 * @param {Object} axios - The Axios instance to use for the request.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getBenchlingProjects = async (axios) => {
  return await axios.get(`${BASEURL}/benchling/get-project`, {});
};

/**
 * Fetches a list of entries from the Benchling API.
 * @param {Object} axios - The Axios instance to use for the request.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getBenchlingEntries = async (axios) => {
  return await axios.get(`${BASEURL}/benchling/get-entries`, {});
};

/**
 * Fetches Benchling schemas based on the modified date.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {string} modifiedAtParam - The date parameter to filter schemas.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getBenchlingSchemas = async (axios, modifiedAtParam) => {
  return await axios.get(`${BASEURL}/benchling/fetch/schema`, {
    params: {
      ModifiedAt: modifiedAtParam,
    },
  });
};

/**
 * Fetches data for a specific Benchling entry using its ID.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {string} entryId - The ID of the entry to fetch data for.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getBenchlingEntryData = async (axios, entryId) => {
  return await axios.get(`${BASEURL}/benchling/fetch/entryId`, {
    params: {
      entryId: entryId,
    },
  });
};

export const BenchlingApi = {
  getBenchlingProjects,
  getBenchlingEntries,
  getBenchlingEntryData,
  getBenchlingSchemas,
};
